/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Export_DoneInputs */

const cs_portals_export_done = /** @type {(inputs: Portals_Export_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export hotov`)
};

const en_portals_export_done = /** @type {(inputs: Portals_Export_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export completed`)
};

/**
* | output |
* | --- |
* | "Export completed" |
*
* @param {Portals_Export_DoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_export_done = /** @type {((inputs?: Portals_Export_DoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Export_DoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_export_done(inputs)
	return cs_portals_export_done(inputs)
});